import { render, staticRenderFns } from "./CambioButacaView.vue?vue&type=template&id=679866ec"
import script from "./CambioButacaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CambioButacaView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports